import React from 'react'
// @ts-ignore
import FormField, { FormLayout } from 'shared/newFormElements'
import { handlePreventAction, isRequired, normalizeIBAN } from '../../../helpers'
import translate from '../../translate'

const ContactPersons = ({ fields, noVisibilityFilter, actionType }) => (
  <>
    {(!!fields.ContactPerson1 || !!fields.ContactPhone1) && (
      <FormLayout
        visible={noVisibilityFilter || !!(fields.ContactPerson1 || fields.ContactPhone1)}
        label={translate('lbl_contact_info_phone1')}
      >
        {!!fields.ContactPerson1 && (
          <FormField
            visible={noVisibilityFilter || !!fields.ContactPerson1}
            name="ContactPerson1"
            required={isRequired(fields.ContactPerson1)}
            maxLength={fields.ContactPerson1 ? fields.ContactPerson1.MaxLen : -1}
          />
        )}
        {!!fields.ContactPhone1 && (
          <FormField
            visible={noVisibilityFilter || !!fields.ContactPhone1}
            name="ContactPhone1"
            type="number"
            dontParseToInt
            required={isRequired(fields.ContactPhone1)}
            maxLength={fields.ContactPhone1 && fields.ContactPhone1.MaxLen}
          />
        )}
      </FormLayout>
    )}
    {(!!fields.ContactPerson2 || !!fields.ContactPhone2) && (
      <FormLayout
        visible={noVisibilityFilter || !!(fields.ContactPerson2 || fields.ContactPhone2)}
        label={translate('lbl_contact_info_phone2')}
      >
        {!!fields.ContactPerson2 && (
          <FormField
            visible={noVisibilityFilter || !!fields.ContactPerson2}
            name="ContactPerson2"
            required={isRequired(fields.ContactPerson2)}
            maxLength={fields.ContactPerson2 ? fields.ContactPerson2.MaxLen : -1}
          />
        )}
        {!!fields.ContactPhone2 && (
          <FormField
            visible={noVisibilityFilter || !!fields.ContactPhone2}
            name="ContactPhone2"
            type="number"
            dontParseToInt
            required={isRequired(fields.ContactPhone2)}
            maxLength={fields.ContactPhone2 && fields.ContactPhone2.MaxLen}
          />
        )}
      </FormLayout>
    )}
    {!!fields.IBANAccNo && (
      <FormLayout visible={noVisibilityFilter || !!fields.IBANAccNo} label={translate('lbl_iban')}>
        <FormField
          name="IBANAccNo"
          required={isRequired(fields.IBANAccNo)}
          maxLength={fields.IBANAccNo ? fields.IBANAccNo.MaxLen : -1}
          normalize={normalizeIBAN()}
          onDrag={handlePreventAction}
          onDrop={handlePreventAction}
        />
      </FormLayout>
    )}

    {(!!fields.PassPhrase || !!fields.IND_DwellingAge) && (
      <FormLayout
        label={actionType !== 'edit' && (noVisibilityFilter || !!fields.PassPhrase) ? translate('lbl_passphrase') : ' '}
      >
        {actionType !== 'edit' && (noVisibilityFilter || !!fields.PassPhrase) ? (
          <FormField
            name="PassPhrase"
            required={isRequired(fields.PassPhrase)}
            maxLength={fields.PassPhrase ? fields.PassPhrase.MaxLen : -1}
          />
        ) : (
          <div />
        )}
        {!!fields.IND_DwellingAge && (
          <FormLayout
            label={translate('lbl_ind_dwellingage_t')}
            labelFieldProportions="8:8"
            visible={noVisibilityFilter || !!fields.IND_DwellingAge}
          >
            <FormField
              name="IND_DwellingAge"
              required={isRequired(fields.IND_DwellingAge)}
              maxLength={fields.IND_DwellingAge ? fields.IND_DwellingAge.MaxLen : -1}
            />
          </FormLayout>
        )}
      </FormLayout>
    )}

    {(!!fields.WorkPlace || !!fields.RegFee) && (
      <FormLayout
        visible={noVisibilityFilter || !!(fields.WorkPlace || fields.RegFee)}
        label={translate('lbl_workplace')}
        labelFieldProportions="4:8"
        fieldProportions="10:2"
      >
        {!!fields.WorkPlace && (
          <FormField
            visible={noVisibilityFilter || !!fields.WorkPlace}
            name="WorkPlace"
            required={isRequired(fields.WorkPlace)}
            maxLength={fields.WorkPlace && fields.WorkPlace.MaxLen}
          />
        )}
        {!!fields.RegFee && (
          <FormField
            visible={noVisibilityFilter || !!fields.RegFee}
            name="RegFee"
            type="number"
            required={isRequired(fields.RegFee)}
            maxLength={fields.RegFee && fields.RegFee.MaxLen}
          />
        )}
      </FormLayout>
    )}
  </>
)

export default ContactPersons
